module.exports = __webpack_public_path__ + "img/2.0f94a864.jpeg";